'use client'
import React, { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from './skeleton/Tabs'

interface NavigationTab {
  name: string
  path: string
}

interface NavigationTabsProps {
  tabs: NavigationTab[]
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({ tabs }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleTabChange = (path: string) => {
    navigate(path)
  }

  const activeTab = useMemo(
    () => tabs.find((t) => location.pathname.includes(t.path))?.path,
    [location.pathname, tabs],
  )

  return (
    <Tabs defaultValue={activeTab || tabs?.[0]?.path}>
      <TabsList>
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.path}
            value={tab.path}
            onClick={() => handleTabChange(tab.path)}>
            {tab.name}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}
